import { render, staticRenderFns } from "./Provideinstructions.vue?vue&type=template&id=11af0bce&scoped=true"
import script from "./Provideinstructions.vue?vue&type=script&lang=js"
export * from "./Provideinstructions.vue?vue&type=script&lang=js"
import style0 from "./Provideinstructions.vue?vue&type=style&index=0&id=11af0bce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af0bce",
  null
  
)

export default component.exports